// ONE section header for every console section (Console v2, founder brief 30 Sep §2): a mono eyebrow
// in the agents' green, then an Archivo 800 headline that is a SENTENCE BUILT FROM REAL DATA — never
// an invented line. When there is nothing to say the headline says so plainly ("Nothing is waiting on
// you."), which is why every caller passes a headline it computed from its own loaded payload rather
// than a static string. The pattern is the one the Rainmaker and the Treasurer already shipped; this
// is that pattern made shared so the other eleven sections stop hand-rolling a page head.
export function SectionHead({ eyebrow, headline, lede, testid, children }) {
  return (
    <header className="sec-head" data-testid={testid ? `${testid}-head` : undefined}>
      <p className="sec-eyebrow">— {eyebrow}</p>
      <h1 className="sec-headline" data-testid={testid ? `${testid}-headline` : undefined}>
        {headline}
      </h1>
      {lede && <p className="sec-lede">{lede}</p>}
      {children}
    </header>
  );
}
